import script from "./CarTari.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarTari.vue?vue&type=script&lang=ts&setup=true"

import "./CarTari.vue?vue&type=style&index=0&id=de9439e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de9439e2"]])

export default __exports__